// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminPagination_pagination__20vY7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border-top: 1px solid var(--border);
  background: var(--gray-50);
  color: var(--gray-600);
  font-size: 0.78rem;
}

.AdminPagination_controls__h\\+QT5 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}

.AdminPagination_pageSizeLabel__qHLF8 {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  white-space: nowrap;
}

.AdminPagination_pageSizeSelect__hYv6B,
.AdminPagination_pageButton__hOsK7 {
  padding: 0.4rem 0.6rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: white;
  color: var(--gray-700);
  font-size: inherit;
}

.AdminPagination_pageButton__hOsK7 {
  cursor: pointer;
  transition: background 0.12s, color 0.12s, border-color 0.12s;
}

.AdminPagination_pageButton__hOsK7:hover:not(:disabled) {
  background: var(--green);
  border-color: var(--green);
  color: white;
}

.AdminPagination_pageButton__hOsK7:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.AdminPagination_pageInfo__tNy-O {
  white-space: nowrap;
}

@media (max-width: 600px) {
  .AdminPagination_pagination__20vY7 {
    align-items: flex-start;
    flex-direction: column;
  }

  .AdminPagination_controls__h\\+QT5 {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminPagination.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,mCAAmC;EACnC,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n  border-top: 1px solid var(--border);\n  background: var(--gray-50);\n  color: var(--gray-600);\n  font-size: 0.78rem;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.pageSizeLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  white-space: nowrap;\n}\n\n.pageSizeSelect,\n.pageButton {\n  padding: 0.4rem 0.6rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: white;\n  color: var(--gray-700);\n  font-size: inherit;\n}\n\n.pageButton {\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s, border-color 0.12s;\n}\n\n.pageButton:hover:not(:disabled) {\n  background: var(--green);\n  border-color: var(--green);\n  color: white;\n}\n\n.pageButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.pageInfo {\n  white-space: nowrap;\n}\n\n@media (max-width: 600px) {\n  .pagination {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .controls {\n    width: 100%;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `AdminPagination_pagination__20vY7`,
	"controls": `AdminPagination_controls__h+QT5`,
	"pageSizeLabel": `AdminPagination_pageSizeLabel__qHLF8`,
	"pageSizeSelect": `AdminPagination_pageSizeSelect__hYv6B`,
	"pageButton": `AdminPagination_pageButton__hOsK7`,
	"pageInfo": `AdminPagination_pageInfo__tNy-O`
};
export default ___CSS_LOADER_EXPORT___;
